export default __webpack_public_path__ + "static/media/BT_Filled_Secondary_Logo_Black.14995701.svg";